var _linearGradient, _linearGradient2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 23,
    viewBox: "0 0 36 23",
    width: 36,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "0%",
    x2: "76.616022%",
    y1: "88.472661%",
    y2: "51.274372%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e2a8de"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fb00ff"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: "26.904247%",
    x2: "98.168696%",
    y1: "51.49419%",
    y2: "87.787363%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff622e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519057081,
    stopColor: "#d92192"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d70be6"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-6 -12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m41.7850852 31.6626231c.1407754.2372231.2149148.5065718.2149148.7807867 0 .859681-.71327 1.5565902-1.5931332 1.5565902h-12.8134596c-.27674 0-.5487072-.0704343-.7891139-.2043655-.7643454-.4258189-1.0306716-1.376425-.594856-2.123238l6.3530401-10.8865624c.1394669-.2389903.3412688-.4375966.5848532-.5755917.761169-.4312166 1.7359952-.1778911 2.1773351.5658183z",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.21644957 31.6009345 10.91846283-18.8115817c.4410471-.7598866 1.4096998-1.0154924 2.1635463-.5709114.2342659.1381583.4293133.3347685.5663734.5709114l10.9184628 18.8115817c.4410472.7598867.1874731 1.7363007-.5663734 2.1808816-.2422693.1428784-.5178991.2181839-.7985865.2181839h-21.83692555c-.87338832 0-1.58140945-.7136941-1.58140945-1.5940804 0-.2829363.07470694-.5607746.21644957-.8049851z",
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.523 27.7072601 2.2602949 3.8936744c.4410472.7598867.1874731 1.7363007-.5663734 2.1808816-.2422693.1428784-.5178991.2181839-.7985865.2181839h-1.8249278c-.27674 0-.5487072-.0704343-.7891139-.2043655-.7643454-.4258189-1.0306716-1.376425-.594856-2.123238z",
    fill: "#ee3fd0",
    opacity: 0.8
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.6fbb95b30185c2d626af98f1c9e092e5.svg";
export { ForwardRef as ReactComponent };